import { PropsWithChildren } from 'react';
import styles from './GoalDetailsPanel.module.scss';

const GoalDetailsPanel = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.goalDetailsPanel}>
      {children}
    </div>
  );
};

export default GoalDetailsPanel;